import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
import { firebase, db } from '../../firebase/Firebase'
import ColType from '../.././Types'
//import IEPDrafts from './IEPDrafts'
//import PersonAvatar from '../../customcomponents/PersonAvatar'
import {
  flattenDoc, getIDFromURL, getTotalPoints,
  getQueryStringParam, createIEPGoalText, awardsIncGoals, FOLDER_CURRENT
} from '../.././Util'
import { Layout, Icon, Button, Form, DatePicker } from 'antd'
import DraftStepContainer from './DraftStepContainer'
const { Content } = Layout
const FormItem = Form.Item

/*
const errorMessage = (description) => {
  message.error(description)
}
*/

class TeacherAddIEPGoalConfirm extends Component {
  state = {
    teacherId: null,
    studentId: null,
    teacher: null,
    iep: null,
    iepParagraph: '',
    totalPoints: null,
    students: [],
    school: null,
    completionDateString: '',
    iepDraft: null,
    tabKey: '1',
    stepNum: 7,
    iepDraftMounted: false,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.search !== nextProps.location.search) {
      if (this.props.form) this.props.form.resetFields()
      this.componentDidMount()
    }
  }

  componentDidMount() {
    var teacherId = getIDFromURL(window.location)
    var studentId = getQueryStringParam('student')
    var draftId = getQueryStringParam('draft')
    console.log(teacherId, studentId)

    this.setState({
      teacherId: teacherId,
      studentId: studentId,
      draftId: draftId,
      tabKey: '1',
    })

    if (draftId) {
      db.collection(ColType.iepDrafts)
        .doc(draftId)
        .get()
        .then((doc) => {
          var draft = flattenDoc(doc)
          this.setState({
            iepDraft: draft,
            iepSelections: draft.iepSelectionsNoCount,
            ieps: draft.ieps,
            iepDraftMounted: true,
          })
        })
    }

    db.collection(ColType.teacher)
      .doc(teacherId)
      .get()
      .then((doc) => {
        var teacher = flattenDoc(doc)
        this.setState({
          teacher: teacher,
        })

        db.collection(ColType.school)
          .doc(teacher.schoolId)
          .get()
          .then((doc) => {
            var school = flattenDoc(doc)
            console.log('School', school)

            this.setState({
              school: school,
            })
          })
      })

    db.collection(ColType.student)
      .doc(studentId)
      .get()
      .then((doc) => {
        var student = flattenDoc(doc)

        this.setState({
          student: student,
        })
      })

    db.collection(ColType.student)
      .where('teacherId', '==', teacherId)
      .get()
      .then((querySnapshot) => {
        var students = []
        var studentDict = {}
        querySnapshot.forEach((doc) => {
          //console.log(doc.id, ' => ', doc.data())
          var student = flattenDoc(doc)
          students.push(student)
          studentDict[student.id] = student
        })

        this.setState({
          students: students,
          studentDict: studentDict,
        })
      })
  }

  progressMonitoringChange = (newValue, iep, index) => {
    console.log('val = ' + newValue, ', idx = ' + index)
    // set the number in the progress monitoring to the new value
    iep.progressMonitoring[index].num = newValue
    iep.totalPoints = getTotalPoints(iep)
    iep.iepParagraph = createIEPGoalText(iep, this.state.student, iep.numProgressMonitoringScores)

    this.setState({
      ieps: this.state.ieps,
    })
  }

  onCompletionDateChange = (date, dateString) => {
    console.log(date, dateString)
    var ieps = this.state.ieps
    ieps.map((iep, index) => {
      iep.completionDate = dateString
      iep.iepParagraph = createIEPGoalText(iep, this.state.student, iep.numProgressMonitoringScores)
      return false
    })

    this.setState({
      ieps: ieps,
      completionDateString: dateString
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err && this.state.completionDateString) {
        console.log("Received values of form:", values)

        this.setState({
          isSubmitting: true,
        }, () => {
          var batch = db.batch()

          // delete draft in batch
          var draftRef = db.collection(ColType.iepDrafts).doc(this.state.draftId)
          batch.delete(draftRef)

          // add accommodations and possibly removalStatement to student
          var studentRef = db.collection(ColType.student).doc(this.state.student.id)
          var updatedStudentObj = {}
          updatedStudentObj.accommodations = this.state.iepDraft.accommodations
          let removalStatement = ''
          if (this.state.iepDraft.hasOwnProperty('removalStatement')) {
            updatedStudentObj.removalStatement = this.state.iepDraft.removalStatement
            if (this.state.iepDraft.removalStatement) {
              removalStatement = this.state.iepDraft.removalStatement
            }
          }

          // update student
          batch.update(studentRef, updatedStudentObj)

          // add all ieps in batch
          this.state.ieps.map((iep, index) => {
            var newDoc = db.collection(ColType.iep).doc()
            // student at the time of creation (used in functions)
            batch.set(newDoc, {
              folder: FOLDER_CURRENT,
              accommodations: this.state.iepDraft.accommodations,
              removalStatement: removalStatement,
              iep: iep,
              student: this.state.student,
              studentId: this.state.student.id,
              teacherId: this.state.teacher.id,
              schoolId: this.state.teacher.schoolId,
              districtId: this.state.teacher.districtId,
              onTrack: false,
              totalMeasurements: 0,
              latestMeasurementTimeStamp: firebase.firestore.FieldValue.serverTimestamp(),
              timeStamp: firebase.firestore.FieldValue.serverTimestamp(),
            })
            return false
          })


          batch.commit().then(() => {
            console.log("Batch added successfully")

            // inc goal awards last
            awardsIncGoals(this.state.teacher, this.state.ieps.length)

            this.setState({
              isSubmitting: false,
            })

            this.props.history.push(
              {
                pathname: '/teacher/student/' +
                  this.state.teacherId + '?student=' +
                  this.state.studentId
              }
            )
          })
            .catch((error) => {
              console.error("Error adding batch: ", error)
              this.setState({
                isSubmitting: false,
              })
            })
        })
      }
    })
  }

  tabChange = (activeKey) => {
    this.setState({ tabKey: activeKey })
  }

  render() {
    const { getFieldDecorator } = this.props.form

    return <div>
      <Layout className="content layout-header-mt">
        <Layout>
          <Content className="min-w-1120">
            <div>
              <DraftStepContainer
                teacherBaseProps={this.props.teacherBaseProps}
                dataLoaded={this.state.iepDraftMounted && this.state.student && this.state.teacher}
              >
                <div>
                  {this.state.student && this.state.teacher ?
                    <div>


                      <div className="w-800 m-lr-auto background-fff br-15">
                        <div className='p-4 bkg-purple br-15'>
                          <div className='flex flex-v-center w-100'>
                            <div>
                              {this.props.teacherBaseProps &&
                                this.props.teacherBaseProps.studentDict &&
                                this.props.teacherBaseProps.studentDict
                                  .hasOwnProperty(this.state.studentId)
                                ?
                                <div className="flex flex-v-center mb-0 font-24">
                                  <div>
                                    <div className='font-20 font-fff'>
                                      IEP Draft for {this.props.teacherBaseProps
                                        .studentDict[this.state.studentId].firstName + ' ' +
                                        this.props.teacherBaseProps
                                          .studentDict[this.state.studentId].lastName}
                                    </div>
                                    <h1 className="font-40 mb-0 font-fff font-bold">
                                      Set Completion Date
                                    </h1>
                                  </div>
                                </div>
                                : ''}
                            </div>
                            <img src="/draft-icons/8.png" alt='draft-iep' width={250} className='ml-auto' />
                          </div>
                        </div>
                        <div className='p-4'>
                          <div>
                            <Form onSubmit={this.handleSubmit}>

                              <h2 className="font-20">
                                {this.state.iepDraft.ieps.length === 1 ?
                                  'When is the completion date for this goal?' :
                                  'When is the completion date for these goals?'}
                              </h2>
                              <div className="w-500">
                                <FormItem
                                  label={'Completion date'}>
                                  {getFieldDecorator('completionDate', {
                                    rules: [{
                                      required: true,
                                      message: 'Select a completion date.'
                                    }],
                                  })(
                                    <DatePicker
                                      size={'large'}
                                      format={"MM/DD/YYYY"}
                                      onChange={this.onCompletionDateChange}
                                    />
                                  )}
                                </FormItem>
                              </div>
                              <FormItem className="mb-0">
                                <div className="pt-4 flex flex-v-center">
                                  {this.state.teacherId && this.state.studentId && this.state.draftId ?
                                    <Link
                                      to={'/teacher/add-goal-accommodations/' +
                                        this.state.teacherId + '?student=' +
                                        this.state.studentId +
                                        '&draft=' + this.state.draftId}
                                      className="font-18"
                                    >
                                      <span className="left-hover-parent text-cyan">
                                        <Icon type="arrow-left" className="mr-1 left-hover-child" />
                                        <span>Previous step</span>
                                      </span>
                                    </Link>
                                    : ''}
                                  <Button
                                    className="lg-btn ml-auto"
                                    type={'primary'}
                                    htmlType="submit"
                                    disabled={this.state.isSubmitting}
                                  >
                                    <Icon
                                      type="plus" />
                                    {!this.state.isSubmitting ?
                                      'Add IEP goals' :
                                      'Adding IEP goals...'}
                                  </Button>
                                </div>
                              </FormItem>

                            </Form>
                          </div>


                        </div>
                      </div>
                    </div>
                    : ''}

                </div>
              </DraftStepContainer>
            </div>

          </Content>
        </Layout>
      </Layout>
    </div>
  }
}

export default Form.create()(TeacherAddIEPGoalConfirm)
